type Props = {
  name: string;
  up?: boolean;
  isString?: boolean;
  isNumber?: boolean;
  isBoolean?: boolean;
  label?: string;
};
export default class TableSortingElem {
  isNumber: boolean;
  label: string | undefined;
  isBoolean: boolean;
  name: string;
  up: boolean;
  isString: boolean;
  constructor({
    name = '',
    up = true,
    isString = false,
    isNumber = false,
    isBoolean = false,
    label,
  }: Props) {
    this.name = name;
    this.up = up;
    this.isString = isString;
    this.isNumber = isNumber;
    this.label = label;
    this.isBoolean = isBoolean;
  }
}
